import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase Configuration
// Project: theyni-men
const firebaseConfig = {
  apiKey: 'AIzaSyB8G_9O_hSZT-VEJZZ_UK7FFwRqQC_kmdU',
  authDomain: 'theyni-men.firebaseapp.com',
  projectId: 'theyni-men',
  storageBucket: 'theyni-men.firebasestorage.app',
  messagingSenderId: '614803518457',
  appId: '1:614803518457:web:b44dd33398d28a23f34328'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
